module.exports = require('./internal/FixedDataTableRoot');



//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/fixed-data-table-2/main.js
// module id = 2625
// module chunks = 4